module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/water@3x_dca102.jpg";